import { Controller, useFormContext } from 'react-hook-form';

import { useTranslation } from '@mint-lib/i18n';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import {
  Input,
  InputHelperText,
  InputLabel,
  InputRoot,
} from '@mint-lib/tw-components';

import BaseSelect from '../../components/BaseSelect.jsx';
import {
  FlowTypesEnum,
  getMapLabelByFlowType,
} from '../../constants/singleFlow.js';
import { type FlowFormInput } from '../../types/singleFlow.js';

const MainInformation = () => {
  const { t } = useTranslation('@myn/approval_v2');

  const isReadOnly = !useIsAllowedPermission('approvalFlowFeature:modify');
  const { control, register, formState } = useFormContext<FlowFormInput>();

  const flowTypeLabels = getMapLabelByFlowType(t);
  const flowTypeFieldOptions = [
    {
      value: FlowTypesEnum.enum.flight,
      label: flowTypeLabels[FlowTypesEnum.enum.flight],
    },
  ];

  return (
    <div className="grid gap-x-2 gap-y-3 md:grid-cols-2">
      <InputRoot className="content-start">
        <InputLabel
          htmlFor="flow-name-field"
          label={t('Flow name{{required}}', { required: '*' })}
          disabled={isReadOnly}
        />
        <Input
          data-dd-action-name="Flow name input field"
          id="flow-name-field"
          color={formState.errors.name ? 'error' : 'default'}
          placeholder={t('Name of the approval flow')}
          disabled={isReadOnly}
          {...register('name')}
        />
        {formState.errors.name?.message ? (
          <InputHelperText
            color="error"
            helperText={formState.errors.name.message.toString()}
          />
        ) : null}
      </InputRoot>
      <div className="content-start">
        <Controller
          name="type"
          control={control}
          render={({ field }) => {
            return (
              <BaseSelect
                id="flow-type-field"
                label={t('Flow type{{required}}', { required: '*' })}
                a11yLabel="Flow type select field"
                value={field.value}
                options={flowTypeFieldOptions}
                onChange={(option) => field.onChange(option.value)}
                disabled
              />
            );
          }}
        />
      </div>
    </div>
  );
};

export default MainInformation;
